module.exports = __webpack_public_path__ + "img/Unidad-10.1118d49f.png";